import { endPoints, getDocBuilderServicendPoint } from "./base-url/api-constants";
import { apiService } from "./base-api-service/base-api-service";
import { readCookie } from "../Util/helper";
import { DEFAULT_USER_GUID } from "../Config/Constants";

class DocBuilderService {
    DocBuilderService(url: string) {
      return getDocBuilderServicendPoint(url);
    }
  
    updateUserGuid(docId:string, userGuid:string) {
      const jwtToken = readCookie("jwtToken");
      const headers = { Authorization: "Bearer" + " " + jwtToken };
      const serviceEndpoint = this.DocBuilderService(
        `${endPoints.docBuilderService.MAP_DOCUMENT.replace(":docId", docId)}`
      );
      return apiService.patch(serviceEndpoint, userGuid, headers);
    }
 
    GeneratePDFPath(docId:string, userId:string) {
        const jwtToken = readCookie("jwtToken");
        const headers = { Authorization: "Bearer" + " " + jwtToken };
        const getDocEndpoint = this.DocBuilderService(
        `${endPoints.docBuilderService.GENERATE_PDF_PATH.replace(":docId", docId).replace(":userId", userId)}`
        );
        return apiService.get(getDocEndpoint, null, headers);
    }

    
  DownloadDocument(docId:string, conversionType:string, regenrateDoc:string) {
    const jwtToken = readCookie("jwtToken"); // localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    let userId = readCookie("userguid");
    if (!userId) {
      userId = DEFAULT_USER_GUID;
    }
    const getDocEndpoint = this.DocBuilderService(
      `${endPoints.docBuilderService.DOCUMENT_DOWNLOAD.replace(":docId", docId)
        .replace(":downloadDocType", conversionType)
        .replace(":docConversionMethod", "SOLID")
        .replace(":version", "v2")
        .replace(":userId", userId)
        .replace(":regenerateDoc", regenrateDoc)}`
    );
    return apiService.get(getDocEndpoint, null, headers);
  }
  ConversionStatus(docId:string, conversionId:string) {
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const getDocEndpoint = this.DocBuilderService(
      `${endPoints.docBuilderService.CONVERSION_STATUS.replace(":docId", docId).replace(":conversionId", conversionId)}`
    );
    return apiService.get(getDocEndpoint, null, headers);
  }

}

export default new DocBuilderService();